<template>
  <div class="box-align-center box-pack-between main">
    <div class="whiteBg" style="padding: 20px">
      <export-more-file ref="exportMoreFile"></export-more-file>
    </div>
  </div>
</template>
<script>
import ExportMoreFile from '@/components/common/exportMoreFile/importExcel';
import { zgsourceAllCategory, saveQuestion } from '@/api/index';
import host from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import * as XLSX from 'xlsx';
var that = null;
export default {
  components: {
    ExportMoreFile,
  },
  data() {
    return {
      addExportVisible: false,
      currentIndex: 0,
      ruleForm: {},
      sortList: [],
      fileList: [],
      tHeader: [],
      title: '',
    };
  },
  mounted() {
    that = this;
  },
  computed: {
    uploadImg() {
      console.log('host', host);
      return host.uploadImgUrl;
    },
    headers() {
      return {
        'bg-token': localStorage.getItem('token'), // 直接从本地获取token就行
      };
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
/deep/.el-submenu .el-menu-item {
  min-width: initial;
}
.main {
  padding: 12px;

  .main-left {
    flex-shrink: 0;
    width: 180px;
  }

  .main-right {
    flex: 1;
  }
}
</style>
